module.exports = __webpack_public_path__ + "img/topborder.f1c26b3f.png";